import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { foldersKeys, RequestTypes } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteFolder = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType<string>,
    RequestTypes['deleteFolder']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...foldersKeys.deleteFolder,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
